import { useTranslation } from 'react-i18next';

/**
 * 待ち状態表示
 * @returns
 */
function WaitComponent() {
  const { t } = useTranslation();
  return <div>{t('お待ちください。')}</div>;
}

export default WaitComponent;
